import {SurchargeGroup, useGetSurchargeGroupsQuery} from "../../../../api/surcharge.slice.ts";
import {DataGrid} from "../../../../components/DataGrid";
import {DataLoadingError} from "../../../../components/DataLoadingError.tsx";
import {DataGridToolbar} from "../../../../components/DataGrid/DataGridToolbar.tsx";
import {Button, ButtonToolbar} from "../../../../components/Button.tsx";
import {useDialogFormContext} from "../../../../components/DialogFormContext.ts";
import {useState} from "react";

export const SurchargeGroupList = () => {
    const {data, isLoading, error} = useGetSurchargeGroupsQuery()

    const {openDialog} = useDialogFormContext()

    const [selectedRow, setSelectedRow] = useState<SurchargeGroup | undefined>();

    const columns = [
        {
            key: "name",
            label: "Name"
        },
        {
            key: "applicableActivityTypes",
            label: "Applicable Activities",
            synthetic: true,
            render: (row: any) => row.applicableActivityTypes.join(", ")
        }
    ]
    return <>
        <DataGridToolbar>
            <ButtonToolbar>
                <Button onClick={() => openDialog()} size={"xs"} glyph={"plus"}>
                    Create
                </Button>
                <Button disabled={!selectedRow} size={"xs"} glyph={"pencil"}
                        onClick={() => openDialog(selectedRow?.id)}>
                    Edit
                </Button>
            </ButtonToolbar>

        </DataGridToolbar>
        <DataLoadingError isLoading={isLoading} error={error}>
            <DataGrid data={data || []}
                      columns={columns}
                      onSelect={row => setSelectedRow(row)}
            />
        </DataLoadingError>
    </>
}